export default (contacts) => contacts.map(({userId}) => userId);
